"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFTAuctionBuilder = void 0;
const enums_1 = require("../enums");
const transactions_1 = require("../transactions");
const nft_exchange_builder_1 = require("./nft-exchange-builder");
class NFTAuctionBuilder extends nft_exchange_builder_1.NFTExchangeTransactionBuilder {
    constructor() {
        super();
        this.data.type = enums_1.NFTTransactionTypes.NFTAuction;
        this.data.fee = transactions_1.NFTAuctionTransaction.staticFee();
        this.data.asset = { nftAuction: {} };
    }
    NFTAuctionAsset(nftAuction) {
        if (this.data.asset && this.data.asset.nftAuction) {
            this.data.asset.nftAuction = {
                ...nftAuction,
            };
        }
        return this;
    }
    instance() {
        return this;
    }
}
exports.NFTAuctionBuilder = NFTAuctionBuilder;
//# sourceMappingURL=nft-auction.js.map